
class Logger {
    static error() {
        console.error.call(console, ...arguments)
    }

    static log() {
        console.log.call(console, ...arguments);
    }

    static info() {
        console.info(...arguments);
    }

    static success() {
        let args = [...arguments];
        args = ['%c' + args.shift(), 'color:green;font-weight:bold', ...args];
        console.info.call(console, ...args);
    }

    static unsuccess() {
        let args = [...arguments];
        args = ['%c' + args.shift(), 'color:#F4511E;font-weight:bold', ...args];
        console.error.call(console, ...args);
        throw args;
    }
}

export default Logger;